module.exports = __webpack_public_path__ + "static/media/high-fuel.9f95736d.svg";